"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z
    .object({
    id: zod_1.z.string().uuid().optional().nullable(),
    name: zod_1.z.string(),
    permissions: zod_1.z.object({
        toCreate: zod_1.z.array(zod_1.z.string()),
        toDelete: zod_1.z.array(zod_1.z.string()).nullable().optional(),
    }),
    geometry: zod_1.z.string().optional().nullable(),
})
    .refine((data) => !(!data.id && !data.geometry), {
    message: 'Geometry is required for new regions',
});
exports.path = '/admin-upsert-region';
//# sourceMappingURL=index.js.map